import React from "react";
import Loading from "../Loading";
import MiniaturaItem from "../MiniaturaItem";

const Miniaturas = ({title,listArticulos,showPrice}) => {
    //let listArticulosSort = listArticulos === null ? listArticulos : listArticulos.sort((a, b) => 0.5 - Math.random());
    let listArticulosSort = listArticulos;
    return (
        <div className="container galeria">
            <div className="row galeria__title">
                <h1>{title}</h1>
            </div>
            <div className="row row-cols-2 row-cols-sm-3 row-cols-md-4">
                {
                    listArticulosSort === null
                    ?   <Loading/>
                    :   listArticulosSort.map( (item,i) => 
                            item.activo &&
                                <MiniaturaItem
                                    item={item}
                                    key={"minItem_"+i}
                                    showPrice={showPrice}
                                />
                            )
                }
            </div>
        </div>
    );
};

export default Miniaturas;